import apiClient from './axiosInstanceStock';

export const getNewStockCountByBoatOwnerId = async (id) => {
  if (!id) {
    throw new Error("Stock ID is required");
  }
  return await apiClient.get(`/getNewStockCountByBoatOwnerId/${id}`);
};
